import config from 'config/config.json';
import appendCSSToHead from 'functions/appendCSSToHead';

// Register JS and CSS for Navbar
export const registerWpResForNav = () => {
  const navStyleUrl = `${config.LUXITY_SHOP_URL}/wp-content/themes/bonline/public/css/custom-navbar-styles/nav-style.css?ver=1.0.0`;
  appendCSSToHead(navStyleUrl);
};
